document.addEventListener("DOMContentLoaded", (event) => {
	const iconListItems = document.querySelectorAll(".et_pb_icon_list_item");
	if (iconListItems && iconListItems.length > 0) {
		const currentURLPath = window.location.pathname.replace(/\/*$/, "").toLowerCase();
		iconListItems.forEach((list) => {
			const dataHref = list.getAttribute("data-href");
			if (!dataHref) return;
			const href = dataHref.replace(/\/*$/, "").toLowerCase();

			if (currentURLPath === href) {
				list.classList.add("is-active");
				list.setAttribute("aria-current", "page");
			}
		});
	}
});
